export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/store/modals-services/modal-terms-conditions.ts"